import { GET_USERS, GET_USER_ROLES } from '../types';

import { getUsersEndpoint, getUserRolesEndpoint } from '../../utils/endpoints';

import requestWrapper from '../requestWrapper';

export const getUsers = () => async dispatch => {
  requestWrapper(dispatch, {
    actionType: GET_USERS,
    requestObject: {
      url: getUsersEndpoint(),
      method: 'GET',
      responseType: 'json'
    },
    errorMessage: 'Error retrieving users'
  });
};

export const getUserRoles = username => async dispatch => {
  console.log('getUserRoles username: ', username);
  requestWrapper(dispatch, {
    actionType: GET_USER_ROLES,
    requestObject: {
      url: getUserRolesEndpoint(username),
      method: 'GET',
      responseType: 'json'
    },
    errorMessage: 'Error retrieving user roles'
  });
};
